/**
 * Registers any custom modules or overrides of existing modules
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import { Quill } from 'react-quill'
import quillEmoji from 'quill-emoji'
import MagicUrl from 'quill-magic-url'
import './QuillModules.scss'

const { EmojiBlot, ShortNameEmoji, ToolbarEmoji } = quillEmoji

// There is still an active issue with https://github.com/quilljs/quill/issues/1768
Quill.debug('error')
Quill.register({
  'formats/emoji': EmojiBlot,
  'modules/emoji-toolbar': ToolbarEmoji,
  'modules/emoji-shortname': ShortNameEmoji,
  'modules/magicUrl': MagicUrl
}, true)
